export const AddressZero = '0x0000000000000000000000000000000000000000';
export const AlternativeAddressZero = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export const wrappedSolAddress = 'So11111111111111111111111111111111111111112';
export const SolSystemProgram = '11111111111111111111111111111111';
//# sourceMappingURL=constants.js.map